import { Routes, RouterModule, } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './main/main.component';
import { MainModule } from './main/main.module';

const appRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'main',
        loadChildren: () => new Promise(function (resolve) {
            (require as any).ensure([], function (require: any) {
                resolve(require('./main/main.module')['MainModule']);
            });
        })
    },
    {
        path: '',
        component: HomeComponent
    }
];

export const appRoutingProviders: any[] = [
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


/** WEBPACK FOOTER **
 ** ./app/app.routes.ts
 **/